require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./magistrale-1-12-1-6.json") })
        }
      }, "path---magistrale-1-12-1-6");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---magistrale-1-12-1-6!./.cache/json/magistrale-1-12-1-6.json
// module id = 483
// module chunks = 231608221292675